import { Component, NgZone, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { Language } from './core/models/language';
import { LanguageService } from './core/services/language.service';


@Component({
    selector: 'login-alert-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(private _translateService: TranslateService, private _ngZone: NgZone) {
    }

    ngOnInit() {
        LanguageService.language$.pipe(filter((language: Language) => !!language)).subscribe(
            (language: Language) => {
                this._translateService.addLangs(['nl-BE', 'fr-BE']);
                this._ngZone.run(() => {
                    this._translateService.use(language.locale);
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts